import React, { useContext, useEffect, useState } from "react";
import { Building, LayoutGrid, LogOut, User } from "lucide-react";

import { Button } from "../ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";

import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setUser, setUserData } from "../../store/slices/userSlice";
import UserService from "../../services/user/user";
import { toastError } from "../ToastNotification";
import { ChatContext } from "../../context/chatContext";
import { resetChatState } from "../../store/slices/chatSlice";

export function UserNav() {
  const { setIsLoggedin } = useContext(ChatContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);
  console.log("user", user);
  const [avatarUrl, setAvatarUrl] = useState("");

  useEffect(() => {
    setAvatarUrl(user?.users?.profile);
  }, [user]);

  const handleLogout = () => {
    localStorage.removeItem("GuideproAI_user");
    localStorage.clear();
    // window.location.pathname = "/";
    dispatch(resetChatState());
    dispatch(setUser(null));
    dispatch(setUserData(false));
    setIsLoggedin(false);
    navigate("/", { replace: true });
  };

  return (
    <DropdownMenu>
      <TooltipProvider disableHoverableContent>
        <Tooltip delayDuration={100}>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger asChild>
              <Button
                variant="outline"
                className="relative h-8 w-8 rounded-full"
              >
                <Avatar className="h-8 w-8 object-cover">
                  {avatarUrl ? (
                    <AvatarImage
                      src={avatarUrl}
                      alt="Avatar"
                      className="object-cover"
                    />
                  ) : (
                    <AvatarFallback className="bg-transparent">
                      {user?.users?.name &&
                        user?.users?.name.slice(0, 1).toUpperCase()}
                    </AvatarFallback>
                  )}
                </Avatar>
              </Button>
            </DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent side="bottom">Profile</TooltipContent>
        </Tooltip>
      </TooltipProvider>

      <DropdownMenuContent
        className="w-56 bg-lightGray text-white border border-white/20 "
        align="end"
        forceMount
      >
        <DropdownMenuLabel className="font-normal border-b-0">
          <div className="flex flex-col space-y-1 pb-2">
            <p className="text-sm font-medium leading-none text-[#8B7CFE]">
              {user?.users?.name || "John Doe"}
            </p>
            <p className="text-xs leading-none text-[#8B7CFE]">
              {user?.users?.email || "johndoe@gmail.com"}
            </p>
          </div>
        </DropdownMenuLabel>
        <div className="py-1 border-t border-white/20">
          <DropdownMenuGroup>
            <DropdownMenuItem className="hover:cursor-pointer" asChild>
              <div
                onClick={() => navigate("/profile")}
                className="flex items-center"
              >
                <User className="w-4 h-4 mr-3" />
                Profile
              </div>
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </div>
        {user?.users?.userType === "Organization" && (
          <div className="py-1 border-t border-white/20">
            <DropdownMenuGroup>
              <DropdownMenuItem className="hover:cursor-pointer" asChild>
                <div
                  onClick={() => navigate("/Organization")}
                  className="flex items-center"
                >
                  <Building className="w-4 h-4 mr-3" />
                  Organization
                </div>
              </DropdownMenuItem>
            </DropdownMenuGroup>
          </div>
        )}
        <div className="py-1 border-t border-white/20">
          <DropdownMenuItem
            className="flex items-center"
            onClick={handleLogout}
          >
            <LogOut className="w-4 h-4 mr-3 text-destructive" />
            Log Out
          </DropdownMenuItem>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
